class Testimonials { 
    constructor(){
        this.DOM = {
            $cards_list: document.querySelector('.reviews__cards__ul'),
            $cards: document.querySelectorAll('.reviews__cards__li'),
            $trg: document.querySelector('.reviews__rotate'),
            $dyna_span: document.querySelector('.reviews__cards__counter__dyna')
        }
        this.init()
    }
        
    init() {
        this.duration = 1.5
        const startValue = 0; // starting number
        this.decrement = window.innerWidth * 0.015
        this.rotationOffset = 0
        this.values = [];
        this.length = this.DOM.$cards.length 
        this.zindex_arr = []
        this.DOM.$cards.forEach(($card, index) => {
            let value = startValue - this.decrement * index
            this.values.push(value);
            this.zindex_arr.push(index );
            gsap.set($card, {  y: value, x: -value })
            $card.style.zIndex = this.zindex_arr[index]
        })
        this.bindEvents()
    }

    updateElements() {
        this.DOM.$cards.forEach(($card, i) => {
            const valueIndex = (i + this.rotationOffset) % this.values.length;
            this.DOM.$dyna_span.textContent =`0${this.rotationOffset + 1}`


            gsap.to($card, { duration: this.duration , y: this.values[valueIndex], x: - this.values[valueIndex], ease: 'power3.out'  })
            $card.style.zIndex = this.zindex_arr[valueIndex] 
        })

    }

    bindEvents() {
        this.rotating = false
        this.DOM.$trg.addEventListener('click', () => {
            if (!this.rotating) {
                this.rotating = true
                gsap.to(this.DOM.$trg, { transformOrigin: 'center center', rotation: "+=180", duration: 0.5, ease: 'power3.out', onComplete: () => this.rotating = false  })
            }
            
            this.rotationOffset = (this.rotationOffset + 1) % this.values.length
            this.updateElements()
        })
        this.DOM.$cards_list.addEventListener('click', (e) => {
            this.DOM.$trg.dispatchEvent(new Event('click'))
        })
    }
}

new Testimonials();